import {AskWrapper, VoteExtraAction,} from 'components/Feed/Ask/AskContentWrapper'
import FeedContext from 'components/Feed/FeedContext'
import {createTimeLineFeed} from 'components/Feed/TimeLineFeed'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {BsEye} from 'react-icons/bs'
import {Link} from 'react-router-dom'
import {renderIf} from 'views/Shared'
import AskContentLayout from '../../../components/Feed/Ask/AskContentLayout'
import AskContentMeta from '../../../components/Feed/Ask/AskContentMeta'
import Count from '../../../components/Feed/Count'
import useTranslate from '../../../modules/local/useTranslate'
import {RiMessage3Line} from "react-icons/ri";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {ItemInfoWithIcon} from "../../AppLocals/Organization/OrganizationEntity";
import {formatSimplifyDate} from "../../../helpers/dateUtils";

const attributes = [
    {
        name: 'total_votes',
        label: 'votes',
    },
    {
        name: 'total_comments',
        label: 'comments',
    },
    {
        name: 'total_views',
        label: 'views',
    },
]

const renderAttribute =
    (value) =>
        ({name, label}) =>
            (
                <Translate key={name}>
                    {(t) => (
                        <div className="flex flex-col items-end">
            <span className="text-sm text-primary font-bold leading-tight">
              {value}
            </span>
                            <p className="text-sm text-color-400 leading-tight">{t(label)}</p>
                        </div>
                    )}
                </Translate>
            )

const renderHeadlineAttribute =
    (value) =>
        ({name, label}) =>
            (
                <Translate key={name}>
                    {(t) => (
                        <div className="flex items-center">
            <span className="text-sm text-primary font-bold leading-tight">
              {value}
            </span>
                            <p className="text-sm text-color-400 leading-tight ml-1">
                                {t(label)}
                            </p>
                        </div>
                    )}
                </Translate>
            )

const QuestionAnswerHeadlineItem = () => {
    const {item, type, handleClick, embed_data, shareUrl, mentions} =
        useContext(FeedContext)

    const t = useTranslate()

    const {creator, avatar, title, description, created, ...rest} = item

    const to = getLinkToDetail(rest)

    return (
        <AskWrapper item={_.get(item, 'content')}>
            <div className="flex flex-col 222-333-444">
                <Link to={to} className="font-bold max-lines-2 text-sm text-color-000 no-underline leading-snug">
                    {title}
                </Link>
                <div className="flex items-baseline gap-1 italic">
                    <span className="text-2xs text-color-500 tracking-wide">{t('posted on the channel')}</span>
                    <Link
                        to={getLinkToDetail(_.get(item, 'container'))}
                        className="font-medium text-xs no-underline text-color-100 leading-tight">
                        {_.get(item, 'container.title')}
                    </Link>
                </div>
            </div>
            <div className="flex items-center gap-2 text-color-400">
                {renderIf(
                    _.get(item, 'total_comments') > 0,
                    <div onClick={() => handleClick('to')}>
                        <ItemInfoWithIcon
                            icon={<RiMessage3Line size={15} className="text-color-400"/>}
                            value={_.get(item, 'total_comments')}
                            className="text-xs flex items-center leading-tight"
                        />
                    </div>
                )}
                {renderIf(
                    _.get(item, 'total_views') > 0,
                    <Count
                        defaultNumber={_.get(item, 'total_views')}
                        key="view"
                        component={BsEye}
                    />
                )}
                <div className="flex-1"/>
                <span className="font-medium text-2xs text-color-400 italic tracking-wider">
                    {formatSimplifyDate(created, 'medium')}
                </span>
            </div>
        </AskWrapper>
    )
}

const AskContentItem = () => {
    const t = useTranslate()
    const {item, type, handleClick, embed_data, shareUrl, mentions} = useContext(FeedContext)

    const {creator, avatar, title, description, created, updated, ...rest} = item

    const to = getLinkToDetail(rest)

    const {isSm} = useContext(LayoutContext)

    return (
        <div className="pl-1 space-y-3">
            <Link
                to={to}
                className="max-lines-2 no-underline text-base">
                {title}
            </Link>
            <div className="FeedCardFooterLine"/>
            {/*<div style={{marginLeft: -42, marginRight: -8}} className="FeedCardFooter flex items-center gap-4">*/}
            {/*    <FeedActions className="justify-between md:justify-around gap-0 md:gap-3 px-0 md:px-2"/>*/}
            {/*</div>*/}
        </div>
    )
}

const FeedAsk = createTimeLineFeed({
    // Wrapper: AskContentWrapper,
    ContentLayout: AskContentLayout,
    ContentMeta: AskContentMeta,
    Content: AskContentItem,
    // Footer: NullAsDefault,
})

const renderFeedAskItem = (item, index) => {

    if (!item) return null

    return (
        <AskWrapper item={_.get(item, 'content', {})}>
            <FeedAsk item={_.get(item, 'content', {})}/>
        </AskWrapper>
    )
}

export const AskItemDiscovery = ({item}) => {
    const t = useTranslate()
    return (
        <div className="w-full flex items-center gap-3 py-2 rounded-lg custom-render-border relative 222-222">
            <VoteExtraAction
                item={item}
                canVote={false}
                vote_status={_.get(item, 'vote_status')}
                total_votes={_.get(item, 'total_votes') || 0}
                total_downvotes={_.get(item, 'total_downvotes') || 0}
            />
            <div className="flex flex-col flex-1">
                <Link
                    to={getLinkToDetail(item)}
                    className="font-semibold leading-tight text-color-000 max-lines-1 no-underline mb-1">
                    {_.get(item, 'title')}
                </Link>
                <div className="flex items-center gap-4 mb-2">
                    <div className="flex items-center gap-1 text-xs">
                        <span className="font-medium">{_.get(item, 'total_views')}</span>
                        <span className="italic text-color-400">
              {t('total views')}
            </span>
                    </div>
                    <div className="flex items-center gap-1 text-xs">
                        <span className="font-medium">{_.get(item, 'total_comments')}</span>
                        <span className="text-xs italic text-color-400">
              {t('total comments')}
            </span>
                    </div>
                </div>
                <div className="flex items-center gap-1 text-2xs italic">
                    <span className="text-color-400">{t('posted on the channel')}</span>
                    <Link
                        to={getLinkToDetail(_.get(item, 'container'))}
                        className="font-medium no-underline text-primary flex-1">
                        {_.get(item, 'container.title')}
                    </Link>
                </div>
            </div>
        </div>
    )
}

export const renderQAHeadLine = (item, index) => {
    return (
        <FeedAsk item={_.get(item, 'content', {})}>
            <div key={index}>
                <QuestionAnswerHeadlineItem/>
            </div>
        </FeedAsk>
    )
}

export default renderFeedAskItem
